export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/40">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg">
            <div className="rounded-2xl overflow-hidden bg-background-800/40 border border-background-700/20">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20dark%20room%20with%20ambient%20warm%20lighting%2C%20comfortable%20seating%2C%20premium%20viewing%20experience%2C%20high%20contrast%20cinematic%20atmosphere&width=700&height=500&seq=about-cinema&orientation=landscape"
                alt="777影院观影体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-7 bg-secondary-500 rounded-full"></div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">关于777影院</h2>
            </div>
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-4">
              <strong className="text-foreground-200">777影院</strong>是一个致力于为影迷提供<strong className="text-foreground-200">高清免费影视资源</strong>的在线观影平台。我们聚合了海量<strong className="text-foreground-200">电影大全</strong>、热门<strong className="text-foreground-200">电视剧全集</strong>及综艺动漫内容，覆盖国产、韩剧、美剧、日剧等全品类。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              平台采用分布式多线路加速技术，确保<strong className="text-foreground-300">超清画质</strong>下依然<strong className="text-foreground-300">流畅不卡顿</strong>。我们坚持<strong className="text-foreground-300">免费无广告</strong>的观影理念，无需注册登录，打开即可享受<strong className="text-foreground-300">极速播放</strong>体验。每日同步更新院线大片与热门剧集，让你第一时间追到最新内容。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed">
              777影院团队持续优化播放器性能与资源覆盖，目前已收录超过<strong className="text-accent-400">12万部影视资源</strong>，支持手机、平板、电脑多端同步，无论在家还是通勤路上都能畅享高清观影。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}